import React, { Component } from "react";
import { ticket, ReactNode } from "react";
import Button from "../../components/CustomButtons/Button.jsx";
import { useSpring, animated } from "react-spring";
import PropTypes from "prop-types";
import logo from "../../images/dut.png";
import dutylogo from "../../images/dutylogo.png";
import favicon from "../../images/logoaDuty.png";
import modalHome from "../../images/modalhome.png";
import addphoto from "../../images/addphoto.png";
import check from "../../images/check.png";
import "./tickets.css";
import { Link } from "react-router-dom";
import errorImg from "../../images/error.png";
import {
  InputBase,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  OutlinedInput
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Assignment from "@material-ui/core/SvgIcon/SvgIcon";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Image from "material-ui-image";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import TextField from "@material-ui/core/TextField";
import DialogContentText from "@material-ui/core/DialogContentText";

import { red } from "@material-ui/core/colors";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import GridList from "@material-ui/core/GridList";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import GridListTile from "@material-ui/core/GridListTile";
import Checkbox from "@material-ui/core/Checkbox";
import Container from "@material-ui/core/Container";

// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Add from "@material-ui/icons/Add";
import CloudUpload from "@material-ui/icons/CloudUpload";
import FolderOpen from "@material-ui/icons/FolderOpen";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import {
  CloudDownloadOutlined,
  Delete,
  FileCopyOutlined,
  FolderOpenOutlined,
  FontDownload,
  PersonAdd
} from "@material-ui/icons";
import FavoriteBorderOutlined from "@material-ui/icons/FavoriteBorderOutlined";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// core components
import Card from "components/Card/Card.jsx";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import product1 from "assets/img/product1.jpg";
import product2 from "assets/img/product2.jpg";
import product3 from "assets/img/product3.jpg";
import ExtendedTables from "../Tables/ExtendedTables";
import dutyConnect from "../../images/DutyConnect.jpeg";
import dutyPlanner from "../../images/DutyPlanner.jpeg";
import dutyControl from "../../images/DutyControl.jpeg";
import color from "@material-ui/core/colors/deepPurple";

class Tickets extends Component {
  constructor(props) {
    super(props);
    const { classes } = this.props;
    this.tickets = {
      tickets: [],
      obj: {}
    };

    this.state = {
      checked: [],
      successTicket: false,
      handleClose2: true,
      img: "",
      titulo: "",
      obs: "",
      item: "",
      valor: "",
      tipo: "Solicitud",
      sucursal: "",
      vencimiento: new Date(),
      score: 3271,
      dutylogo: dutylogo,
      imagePreviewUrl: addphoto,
      modalTicket: false,
      modalErrorStatus: false,
      openTicket: false,
      finishTicket: false,
      backButton: false,
      data: [
        [
          "3265",
          this.showModalTicketFinish("Solicitud", "3265"),
          this.showModalTicketFinish("Solicitud de Uniforme", "3265"),
          this.showModalTicketFinish("Córdoba", "3265"),
          this.user(),
          "30/10/2019",
          "01/11/2019",
          "-"
        ],
        [
          "3266",
          this.showModalTicketFinish("Solicitud", "3266"),
          this.showModalTicketFinish("Solicitud de Uniforme", "3266"),
          this.showModalTicketFinish("Chaco", "3267"),
          this.user(),
          "31/10/2019",
          "01/11/2019",
          "-"
        ],
        [
          "3267",
          this.showModalTicketFinish("Reclamo", "3267"),
          this.showModalTicketFinish("Reclamo de Apertura", "3267"),
          this.showModalTicketFinish("Misiones", "3267"),
          this.user(),
          "01/11/2019",
          "05/11/2019",
          "-"
        ],
        [
          "3268",
          this.showModalTicketFinish("Reclamo", "3268"),
          this.showModalTicketFinish("Reclamo de Cierre", "3268"),
          this.showModalTicketFinish("Córdoba", "3268"),
          this.user(),
          "02/11/2019",
          "02/11/2019",
          "-"
        ],
        [
          "3269",
          this.showModalTicketFinish("Idea", "3269"),
          this.showModalTicketFinish("Idea de mejora", "3269"),
          this.showModalTicketFinish("Salta", "3269"),
          this.user(),
          "01/11/2019",
          "04/11/2019",
          "-"
        ],
        [
          "3270",
          this.showModalTicketFinish("Idea", "3270"),
          this.showModalTicketFinish("Idea de implementación", "3270"),
          this.showModalTicketFinish("Córdoba", "3270"),
          this.user(),
          "02/11/2019",
          "03/11/2019",
          "-"
        ]
      ],
      currentData: [],
      realData: [
        [
          "3265",
          "Solicitud",
          "Solicitud de Uniforme",
          "Córdoba",
          this.user(),
          "30/10/2019",
          "01/11/2019",
          "-"
        ],
        [
          "3266",
          "Solicitud",
          "Solicitud de Uniforme",
          "Chaco",
          this.user(),
          "31/10/2019",
          "01/11/2019",
          "-"
        ],
        [
          "3267",
          "Reclamo",
          "Reclamo de Apertura",
          "Misiones",
          this.user(),
          "01/11/2019",
          "05/11/2019",
          "-"
        ],
        [
          "3268",
          "Reclamo",
          "Reclamo de Cierre",
          "Córdoba",
          this.user(),
          "02/11/2019",
          "02/11/2019",
          "-"
        ],
        [
          "3269",
          "Idea",
          "Idea de mejora",
          "Salta",
          this.user(),
          "01/11/2019",
          "04/11/2019",
          "-"
        ],
        [
          "3270",
          "Idea",
          "Idea de implementación",
          "Córdoba",
          this.user(),
          "02/11/2019",
          "03/11/2019",
          "-"
        ]
      ],
      realCurrentData: [],
      dataForTickets: [],
      isEditing: false
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }
  componentDidMount() {
    this.setState({
      currentData: this.state.data,
      realCurrentData: this.state.realData
    });
  }
  user = () => {
    const { classes } = this.props;
    return [{ color: "info", icon: FileCopyOutlined }].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
        >
          <img src={favicon} className={classes.icon} />
        </Button>
      );
    });
  };
  showModalTicketFinish = (campo, id) => {
    const { classes } = this.props;
    return [{ color: "github" }].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
          onClick={() => {
            this.setModalFinishTicket(true, id);
          }}
        >
          <Typography style={{ fontSize: 12 }}>{campo}</Typography>
        </Button>
      );
    });
  };
  createDataForTicketsInput = () => {
    const { classes } = this.props;
    return [{ color: "github" }].map((prop, key) => {
      return (
        <InputBase
          className={classes.input}
          placeholder="Item"
          //value={this.state.item}
          inputProps={{
            "aria-label": "description",
            onChange: e => {
              this.setState({ item: e.target.value });
            }
          }}
        />
      );
    });
  };
  createDataForTicketsValue = () => {
    const { classes } = this.props;
    return [{ color: "github" }].map((prop, key) => {
      return (
        <FormControl className={classes.formControl} variant="outlined">
          <OutlinedInput
            id="component-outlined"
            placeholder="Valor"
            //value={this.state.valor}
            inputProps={{
              "aria-label": "description",
              onChange: e => {
                this.setState({ valor: e.target.value });
              }
            }}
          />
        </FormControl>
      );
    });
  };
  addDataForTickets = () => {
    const newData = [
      this.createDataForTicketsInput(),
      this.createDataForTicketsValue()
    ];
    this.setState({ dataForTickets: [...this.state.dataForTickets, newData] });
  };
  handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let Ticket = e.target.tickets[0];
    if (Ticket) {
      reader.onloadend = () => {
        this.setState({
          ticket: Ticket,
          imagePreviewUrl: reader.result
        });
      };
      reader.readAsDataURL(Ticket);
    }
  };
  modalError = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalErrorStatus}
        open={this.state.modalErrorStatus}
        onClose={() => {
          this.setState({ modalErrorStatus: false });
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: 350,
            height: 320,
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2"></CardContent>
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={errorImg}
            title="error"
          ></CardMedia>
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Error
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              Debes completar todos los campos.
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.setState({ modalErrorStatus: false });
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
      </Modal>
    );
  };
  _tabla = () => {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <Table
                tableHead={[
                  "Nro",
                  "Tipo",
                  "Título",
                  "Sucursal",
                  "Usuario",
                  "F. Creación",
                  "F. Vencimiento",
                  "Estado"
                ]}
                tableData={this.state.currentData}
                customCellClasses={[
                  classes.left,
                  classes.left,
                  classes.left,
                  classes.right,
                  classes.right,
                  classes.right,
                  classes.right,
                  classes.center
                ]}
                customClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7]}
                customHeadCellClasses={[
                  classes.left,
                  classes.left,
                  classes.left,
                  classes.right,
                  classes.right,
                  classes.right,
                  classes.right,
                  classes.right
                ]}
                customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };
  setModalSuccessTicket = prop => {
    this.setState({ successTicket: prop });
  };
  setModalTicket = prop => {
    this.setState({
      openTicket: prop,
      Ticket: null,
      tipo: "Solicitud",
      titulo: "",
      sucursal: "",
      obs: "",
      item: "",
      valor: "",
      dataForTickets: [],
      vencimiento: new Date()
    });
  };
  setModalFinishTicket(prop, id) {
    const position = this.state.realCurrentData.filter(
      data => data[0] === id
    )[0];
    this.setState({
      tipo: position[1],
      titulo: position[2],
      sucursal: position[3],
      vencimiento: position[6],
      obs: position[8],
      item: position[10],
      valor: position[11],
      isEditing: true
    });
    this.setState({ openTicket: prop });
  }
  getCurrentDate() {
    let newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`;
  }
  incrementarScore() {
    console.log(this.state.score);
    this.setState({
      score: (this.state.score += 1)
    });
  }
  handleDateChange = date => {
    this.setState({ vencimiento: date });
  };
  _newTicket = () => {
    const { score, tipo, titulo, sucursal, vencimiento, obs, item, valor } = this.state;
    const dueDate = format(vencimiento, "dd/MM/yyyy");
    if (!(tipo, sucursal, dueDate)) {
      this.setState({ modalErrorStatus: true });
    } else {
      const ticket = [
        score,
        this.showModalTicketFinish(tipo, score),
        this.showModalTicketFinish(titulo, score),
        this.showModalTicketFinish(sucursal, score),
        this.user(),
        this.getCurrentDate(),
        dueDate,
        "-"
      ];
      const realTicket = [
        score,
        tipo,
        titulo,
        sucursal,
        this.user(),
        this.getCurrentDate(),
        vencimiento,
        "-",
        obs,
        item,
        valor
      ];
      this.setState(
        {
          currentData: [...this.state.currentData, ticket],
          realCurrentData: [...this.state.realCurrentData, realTicket],
          Ticket: null,
          tipo: "Solicitud",
          titulo: "",
          sucursal: "",
          obs: "",
          item: "",
          valor: "",
          dataForTickets: [],
          vencimiento: new Date()
        },
        () => {
          this.setModalTicket(false);
          this.setModalSuccessTicket(true);
          this.incrementarScore(score);
        }
      );
    }
  };
  _modalSuccessTicket = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.successTicket}
        onClose={() => {
          this.setModalSuccessTicket(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card
            item
            xs={12}
            className="cardModal"
            style={{
              width: "50%",
              height: "60%",
              alignItems: "center"
            }}
          >
            <CardContent>
              <img
                src={check}
                style={{ height: "50%", width: "100%", margin: "auto" }}
              />
            </CardContent>
            {/*            <CardMedia
              style={{ height: "50%", width: "50%", margin: "auto" }}
              className="textCardNov"
              image={check}
              title="check"
            />*/}
            <CardContent className="textCardNov2">
              <Typography
                className="titCard"
                style={{ textAlign: "center" }}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Ticket creado con éxito
              </Typography>
              <Typography
                variant="txtCardNov"
                color="textSecondary"
                component="p"
              >
                Has creado un nuevo Ticket, podrás seguir el estado en el que se
                encuentra
              </Typography>
              <Button
                className="btn2"
                onClick={() => {
                  this.setModalSuccessTicket(false);
                }}
              >
                <Typography className="btnNewNov2">ACEPTAR</Typography>
              </Button>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  _modalTicket = () => {
    const { classes } = this.props;
    return [{ color: "info", icon: FileCopyOutlined }].map((prop, key) => {
      return (
        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          className={useStyles.modal}
          open={this.state.openTicket}
          style={{
            overflow: "scroll",
            alignContent: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
          onClose={() => {
            this.setModalTicket(false);
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <div style={{ width: "80%" }}>
            <Card
              className=""
              style={{
                margin: "auto",
                padding: 20
              }}
            >
              {/*{this._pickImage()}*/}
              <CardContent className="textCardModal">
                <Typography
                  gutterBottom
                  variant="h4"
                  component="h2"
                  style={{ fontWeight: "bold" }}
                >
                  Tipos >
                  <FormControl className={classes.formControl}>
                    <Select
                      id="demo-simple-select"
                      name="age"
                      value={this.state.tipo}
                      inputProps={{
                        onChange: e => {
                          this.setState({ tipo: e.target.value });
                        }
                      }}
                      style={{
                        marginTop: -7,
                        marginBottom: 0,
                        marginLeft: 10,
                        fontSize: "2.125rem",
                        padding: 0,
                        fontWeight: "bold"
                      }}
                    >
                      <MenuItem value={"Solicitud"}>Solicitudes</MenuItem>
                      <MenuItem value={"Reclamo"}>Reclamos</MenuItem>
                      <MenuItem value={"Idea"}>Ideas</MenuItem>
                    </Select>
                  </FormControl>
                </Typography>
                <div
                  style={{
                    width: "100%",
                    paddingBottom: 12,
                    borderBottom: "1px solid #dedede"
                  }}
                >
                  <img
                    src={favicon}
                    className={classes.icon}
                    style={{ width: 40, height: "auto" }}
                  />
                  <span style={{ fontSize: 24 }}> > </span>
                  <img
                    src={modalHome}
                    className={classes.icon}
                    style={{ width: 40, height: "auto" }}
                  />
                </div>
              </CardContent>
              <CardContent className="textCardModal">
                <div
                  style={{ width: "100%", borderBottom: "1px solid #dedede" }}
                >
                  <InputBase
                    className={classes.input}
                    placeholder="Título"
                    value={this.state.titulo}
                    inputProps={{
                      onChange: e => {
                        this.setState({ titulo: e.target.value });
                      },
                      type: "text"
                    }}
                    fullWidth
                    style={{
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: 24,
                      fontWeight: "bold"
                    }}
                  />
                  <InputBase
                    className={classes.input}
                    placeholder="Observación"
                    value={this.state.obs}
                    inputProps={{
                      onChange: e => {
                        this.setState({ obs: e.target.value });
                      },
                      type: "text"
                    }}
                    fullWidth
                    multiline
                    rows={5}
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      fontSize: 18
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    paddingTop: 20,
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <FormControl
                    className={classes.formControl}
                    style={{ width: "49%" }}
                  >
                    <InputLabel shrink id="demo-simple-select-label">
                      Sucursal
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      name="age"
                      value={this.state.sucursal}
                      inputProps={{
                        onChange: e => {
                          this.setState({ sucursal: e.target.value });
                        }
                      }}
                      style={{
                        marginTop: 20,
                        marginBottom: 0,
                        marginRight: 10,
                        padding: 0
                      }}
                    >
                      <MenuItem value={"Buenos Aires"}>Buenos Aires</MenuItem>
                      <MenuItem value={"Córdoba"}>Córdoba</MenuItem>
                      <MenuItem value={"Santa Fe"}>Santa Fe</MenuItem>
                      <MenuItem value={"Mendoza"}>Mendoza</MenuItem>
                      <MenuItem value={"Catamarca"}>Catamarca</MenuItem>
                      <MenuItem value={"Chaco"}>Chaco</MenuItem>
                      <MenuItem value={"Chubut"}>Chubut</MenuItem>
                      <MenuItem value={"Corrientes"}>Corrientes</MenuItem>
                      <MenuItem value={"Entre Ríos"}>Entre Ríos</MenuItem>
                      <MenuItem value={"Formosa"}>Formosa</MenuItem>
                      <MenuItem value={"Jujuy"}>Jujuy</MenuItem>
                      <MenuItem value={"La Pampa"}>La Pampa</MenuItem>
                      <MenuItem value={"La Rioja"}>La Rioja</MenuItem>
                      <MenuItem value={"Misiones"}>Misiones</MenuItem>
                      <MenuItem value={"Neuquén"}>Neuquén</MenuItem>
                      <MenuItem value={"Río Negro"}>Río Negro</MenuItem>
                      <MenuItem value={"Salta"}>Salta</MenuItem>
                      <MenuItem value={"San Juan"}>San Juan</MenuItem>
                      <MenuItem value={"San Luis"}>San Luis</MenuItem>
                      <MenuItem value={"Santa Cruz"}>Santa Cruz</MenuItem>
                      <MenuItem value={"Santiago del Estero"}>
                        Santiago del Estero
                      </MenuItem>
                      <MenuItem value={"Tierra del Fuego"}>
                        Tierra del Fuego
                      </MenuItem>
                      <MenuItem value={"Tucumán"}>Tucumán</MenuItem>
                    </Select>
                  </FormControl>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      margin="normal"
                      id="date-picker-dialog"
                      label="Vencimiento"
                      format="dd/MM/yyyy"
                      minDate={new Date()}
                      value={this.state.vencimiento}
                      onChange={this.handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date"
                      }}
                      style={{
                        width: "49%",
                        marginTop: 4,
                        marginBottom: 0,
                        marginLeft: 10,
                        padding: 0
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div style={{ width: "100%", marginTop: 20 }}>
                  <Fab
                    variant="extended"
                    aria-label="add"
                    className="btn2"
                    onClick={() => {
                      this.addDataForTickets();
                    }}
                    style={{
                      width: "90%",
                      backgroundColor: "lightgrey",
                      display: "flex",
                      margin: "auto",
                      color: "white",
                      marginBottom: 15
                    }}
                  >
                    <AddIcon /> Nuevo Item
                  </Fab>
                  <Table
                    tableData={this.state.dataForTickets}
                    customCellClasses={[classes.left, classes.right]}
                    customClassesForCells={[0, 1]}
                    customHeadCellClasses={[classes.left, classes.right]}
                    customHeadClassesForCells={[0, 1]}
                  />
                </div>
              </CardContent>
              <CardContent className="buttomNewNod">
                {!this.state.isEditing ? (
                  <div
                    className="buttonsHed"
                    style={{ width: "100%", display: "contents" }}
                  >
                    <Button
                      style={{ width: "50%" }}
                      className="btn1"
                      onClick={() => {
                        this.setModalTicket(false);
                      }}
                    >
                      <Typography className="btnNewNov1">CANCELAR</Typography>
                    </Button>
                    <Button
                      style={{ width: "50%" }}
                      className="btn2"
                      onClick={() => {
                        this._newTicket();
                      }}
                    >
                      <Typography className="btnNewNov2">ENVIAR</Typography>
                    </Button>
                  </div>
                ) : (
                  <Button
                    style={{ width: "50%" }}
                    className="btn2"
                    onClick={() => {
                      this.setModalTicket(false);
                    }}
                  >
                    <Typography className="btnNewNov2">Aceptar</Typography>
                  </Button>
                )}
              </CardContent>
            </Card>
          </div>
        </Modal>
      );
    });
  };
  _modalTicketFinish = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.finishTicket}
        style={{ overflow: "scroll", alignContent: "center" }}
        onClose={() => {
          this.setModalFinishTicket(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card
            className="cardModal"
            style={{
              paddingTop: 20,
              width: window.innerWidth < 600 ? "70%" : "50%"
            }}
          >
            <CardContent className="textCardModal">
              <Typography gutterBottom variant="h5" component="h2">
                Acá tengo que poner el modal de Ticket wachooooooooooooo
              </Typography>
              <div style={{ width: "100%" }}></div>
            </CardContent>
            <CardContent className="buttomNewNod">
              <div
                className="buttonsHed"
                style={{ width: "100%", display: "contents" }}
              >
                <Button
                  style={{ width: "50%" }}
                  className="btn2"
                  onClick={() => {
                    this.setModalFinishTicket(false);
                  }}
                >
                  <Typography className="btnNewNov2">ACEPTAR</Typography>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Header />
        <Toolbar />
        <div
          style={{
            paddingTop: window.innerWidth < 600 ? 70 : 10,
            paddingBottom: 20
          }}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
            spacing={3}
            style={{ width: "100%" }}
          >
            <Grid item xs={12} sm={6}>
              <Typography className="novTit">Tickets</Typography>
            </Grid>
            <Grid
              className="titMod2"
              item
              xs={12}
              sm={6}
              style={{ width: "100%" }}
            >
              <div className="divbtn3">
                <Button
                  className="btn3"
                  onClick={() => {
                    this.setModalTicket(true);
                    this.setState({ isEditing: false });
                  }}
                >
                  <Add className="btn3icon" />
                  <Typography className="txtb3">Crear Ticket</Typography>
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        {this._tabla()}
        <div style={{ height: "100%" }}>
          {this._modalTicket()}
          {this._modalTicketFinish()}
          {this._modalSuccessTicket()}
          {this.modalError()}
        </div>
      </React.Fragment>
    );
  }
}
function Header(props) {
  return (
    <ElevationScroll {...props}>
      <AppBar>
        <Toolbar
          style={{ backgroundColor: "#fff", paddingLeft: 0, paddingRight: 0 }}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ padding: 20, paddingBottom: 10 }}
            >
              <div>
                <Link to="/">
                  <img src={logo} className="App-logo" alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
              xs={12}
              sm={6}
              style={{
                padding: 10,
                flexWrap: "nowrap",
                justifyContent: "center",
                marginBottom: 10
              }}
            >
              <div style={{ width: "40%", marginRight: 5 }}>
                <Link to="/">
                  <Button
                    className="btn1"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#fff"
                    }}
                  >
                    <ArrowBack className="btn1icon" style={{}} />
                    <Typography className="txtb1" style={{ fontSize: 12 }}>
                      Seguir probando
                    </Typography>
                  </Button>
                </Link>
              </div>
              <div style={{ width: "40%", marginLeft: 5 }}>
                <Link to="/finish">
                  <Button
                    className="btn2"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#F50027"
                    }}
                  >
                    <Typography className="txtb2">
                      Probar 14 días gratis{" "}
                    </Typography>
                  </Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
}
function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
}
const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return (
    <animated.div
      ref={ref}
      style={[
        style,
        { flexDirection: "row", flex: 1, justifyContent: "center" }
      ]}
      {...other}
    >
      {children}
    </animated.div>
  );
});
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func
};
const useStyles = makeStyles(theme => ({
  card: {
    width: "65%",
    marginBottom: 15,
    height: 300
  },
  media: {
    height: 300,
    paddingTop: "56.25%" // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
    overflow: "scroll",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  textField: {
    width: "100%",
    marginTop: 0,
    fontSize: 15
  },
  /*  customCardContentClass: {
    paddingLeft: "0",
    paddingRight: "0"
  },*/
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
}));

Tickets.propTypes = {
  classes: PropTypes.object
};

export default withStyles(extendedTablesStyle)(Tickets);
